/**
 * ## cortex:std:debug
 * Module to "assert" certain criteria within the code. If code is being
 * executed in a production environment it'll throw an error. If code is being
 * executed in a development environment call "debugger" first.
 *
 * ### Code example
 *
 * ```ts
 * const valueFromService = getValueFromService()!;
 * // throws an error if null or undefined. If dev env it'll launch the debugger before the throw
 * Debug.assertDeclared(valueFromService);
 *
 * // continue with valueFromService being defined
 * ```
 */
export var Debug;
(function (Debug) {
    /** Asserts value's truthiness, if false -> fail */
    function assert(expression, message) {
        if (!expression) {
            fail(`error ${message}`);
        }
    }
    Debug.assert = assert;
    /** Asserts that value is not undefined or null */
    function assertDeclared(value, message) {
        if (typeof value === 'undefined' || value === null) {
            fail(`error ${message}`);
        }
        return true;
    }
    Debug.assertDeclared = assertDeclared;
    function fail(message) {
        if (process.env.NODE_ENV === 'development') {
            debugger;
        }
        throw new Error(message);
    }
})(Debug || (Debug = {}));
